import { getYearDays } from './get-year-days';
import { _holidaysForStaffingCalendar } from './_holidays-for-staffing-calendar';

export function calendariumDays(year: string) {
  return getYearDays(year, _holidaysForStaffingCalendar);
}
